import Axios from '../utils/Axios';

export const CALL_TYPE_RECEIVER = 'RECEIVER';
export const CALL_TYPE_SENDER = 'SENDER';

export type InterphoneAreaType = {
  card_id: number | null;
  card_title: string | null;
  close_time: string;
  description: string;
  hotel_area_id: number;
  name: string;
  open_time: string;
  registerByThisDevice: boolean;
  registerDeviceCount: number;
};

export type MissedCallType = {
  manage_id: number;
  sender: string;
  sender_id: number;
  sender_name: string;
  called_at: string;
};

const InterphoneController = {
  registerFcmForHotelArea: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/registerFcmForHotelArea`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 기기 등록 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  unregisterFcmIdFromHotelArea: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL +
        `/api/interphone/unregisterFcmIdFromHotelArea`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 기기 등록 해제 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  requestVoiceChat: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/requestVoiceChat`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 채팅 요청 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  cancelVoiceChat: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/cancelVoiceChat`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 채팅 취소 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  acceptVoiceChat: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/acceptVoiceChat`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 채팅 수락 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  getCallers: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/getCallers`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 채팅 대상 불러오기 오류]' + err.toString(),
        data: undefined,
      };
    }
  },

  getInterphoneUseStatus: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/getInterphoneUseStatus`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 기능 사용 여부 가져오기 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  setInterphoneUseStatus: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/setInterphoneUseStatus`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 기능 사용 여부 설정 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  createHotelArea: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/createHotelArea`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 호텔 구역 생성 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  updateHotelArea: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/updateHotelArea`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 호텔 구역 수정 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  delHotelArea: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/delHotelArea`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 호텔 구역 삭제 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  hotelAreaList: async (params: any): Promise<any> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/hotelAreaList`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 호텔 구역 리스트 가져오기 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  getUnavailableCalls: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/getUnavailableCalls`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[부재중 목록 가져오기 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  checkUnavailableCall: async (params: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/checkUnavailableCall`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[부재중 확인 처리 오류]' + err.toString(),
        data: undefined,
      };
    }
  },
  setReqCallDataReceived: async (oParams: any): Promise<any> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/interphone/setReqCallDataReceived`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err: any) {
      return {
        ok: false,
        msg: '[인터폰 수신 확인 처리 오류]' + err.toString(),
        data: null,
      };
    }
  },
};

export default InterphoneController;
